import React from "react";

function Footer() {
  return (
    <footer className="bg-dark text-light text-center py-3">
      <p>
        &copy; 2024 <strong className="text-warning">Mohamed Ahmed</strong>{" "}
        Blog. All Rights Reserved.
      </p>
    </footer>
  );
}

export default Footer;
